module.exports = __webpack_public_path__ + "img/former-bg1-cn.aa4d6957.png";